define('load.css',function(require,exports,module){

    function $loadCss(path,callback){
        if(!path){return;}
        var l;
        if(!window["_loadCss"] || window["_loadCss"].indexOf(path)<0){
            l = document.createElement('link');
            l.setAttribute('type', 'text/css');
            l.setAttribute('rel', 'stylesheet');
            l.setAttribute('href', path);
            l.setAttribute("id","loadCss"+Math.random());
            document.getElementsByTagName("head")[0].appendChild(l);
            window["_loadCss"]?(window["_loadCss"]+="|"+path):(window["_loadCss"]="|"+path);
        }

        l&&(typeof callback=="function")&&(l.onload=callback);

        return true;

    }
    exports.loadCss=$loadCss;

});


// WEBPACK FOOTER //
// ./../common/js/load.css.js